export default function LoadingVendor() {
  return (
    <>
      <main className="animate-pulse flex gap-2 max-w-screen-2xl mx-auto pt-10 pb-16">
        <div className="w-1/2 px-4 px-6 bg-neutralColor-light rounded-md shadow-md h-screen py-5 flex flex-col gap-20">
          <div className="space-y-5">
            <span className="block rounded-full w-32 h-4 bg-neutralColor-light"></span>
            <span className="block rounded-full w-52 h-2 bg-neutralColor-light"></span>
          </div>
          <div className="space-y-5">
            <div className="space-y-2">
              <span className="block rounded-full w-32 h-2 bg-neutralColor-light"></span>
              <span className="block rounded-full w-48 h-2 bg-neutralColor-light"></span>
            </div>
            <div className="space-y-2">
              <span className="block rounded-full w-32 h-2 bg-neutralColor-light"></span>
              <span className="block rounded-full w-48 h-2 bg-neutralColor-light"></span>
            </div>
            <div className="space-y-2">
              <span className="block rounded-full w-32 h-2 bg-neutralColor-light"></span>
              <span className="block rounded-full w-48 h-2 bg-neutralColor-light"></span>
            </div>
            <div className="space-y-2">
              <span className="block rounded-full w-32 h-2 bg-neutralColor-light"></span>
              <span className="block rounded-full w-48 h-2 bg-neutralColor-light"></span>
            </div>
            <div className="space-y-2">
              <span className="block rounded-full w-32 h-2 bg-neutralColor-light"></span>
              <span className="block rounded-full w-48 h-2 bg-neutralColor-light"></span>
            </div>
          </div>
        </div>
        <div className="w-full px-4 px-6 bg-neutralColor-light rounded-md shadow-md h-screen">
          <span className="mt-5 block rounded-full w-32 h-4 bg-neutralColor-light"></span>
          <div className="grid grid-cols-2 mt-12 gap-12">
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
            <div>
              <span className="block rounded-full w-20 h-2 bg-neutralColor-light"></span>
              <span className="mt-2 block rounded-full w-32 h-2 bg-neutralColor-light"></span>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
